<template>
  <v-container id="user-tables" fluid tag="section">
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="keyword"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        @input="doSearch"
      >
      </v-text-field>
    </v-card-title>
    <v-data-table
      ref="vDataTable"
      :headers="headers"
      :items="orders"
      hide-default-footer
      class="elevation-0"
    >
      <template #item="{ item, index, headers }">
        <tr>
          <td>
            {{ index + 1 + (page - 1) * 10 }}
          </td>
          <td class="hidden-sm-and-down">
            {{ item.created_at }}
          </td>
          <td>
            {{ item.invoice_number }}
          </td>
          <td>Rp. {{ item.total_order }}</td>
          <td>
            <v-text v-if="item.profit_and_loss_qty <= 0" class="red--text"
              >Rp. {{ item.profit_and_loss_qty }}</v-text
            >
            <v-text v-else>Rp. {{ item.profit_and_loss_qty }} </v-text>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center">
      <v-pagination
        v-model="page"
        @input="go"
        :length="lengthPage"
        :total-visible="5"
        color="#1b5e20"
      ></v-pagination>
    </div>
    <div class="text-center">
      <v-dialog v-model="progressBar" width="100" hide-overlay>
        <v-progress-circular
          :size="60"
          color="primary"
          indeterminate
          align-center
          justify-center
        >
        </v-progress-circular>
      </v-dialog>
    </div>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      orders: [],
      keyword: "",
      page: 0,
      lengthPage: 0,
      headers: [
        { text: "No", value: "id" },
        { text: "Date", value: "created_at" },
        { text: "Invoice", value: "invoice_number" },
        { text: "Total Order", value: "total_order" },
        { text: "Profit / Invoice", value: "profit_and_loss_qty" },
      ],
      progressBar: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },

  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setAuth: "auth/set",
    }),
    go() {
      this.progressBar = true;
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/orders/profit-orders?page=" + this.page;
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          let { meta } = response.data;
          this.orders = data;
          this.lengthPage = meta.last_page;
          this.page = meta.current_page;
          this.progressBar = false;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    doSearch() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let keyword = this.keyword;
      if (keyword.length > 0) {
        this.axios
          .get("/orders/search/profit-orders/" + keyword, config)
          .then((response) => {
            let { data } = response.data;
            this.orders = data;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.go();
      }
    },
  },
  created() {
    this.go();
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.position-relative {
  position: relative;
}
</style>
